import { render } from "./Storage Types.vue?vue&type=template&id=01e56ee6"
import script from "./Storage Types.vue?vue&type=script&lang=js"
export * from "./Storage Types.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__